import { Loader2 } from "lucide-react";
import { motion, AnimatePresence } from "framer-motion";

interface AnalysisProgressBarProps {
  analyzingCount: number;
  totalRecentDocs: number;
}

export function AnalysisProgressBar({ 
  analyzingCount, 
  totalRecentDocs 
}: AnalysisProgressBarProps) {
  if (analyzingCount === 0) return null;
  
  const completedCount = Math.max(0, totalRecentDocs - analyzingCount);
  const progress = totalRecentDocs > 0 ? (completedCount / totalRecentDocs) * 100 : 0;
  
  return (
    <AnimatePresence>
      <motion.div 
        initial={{ opacity: 0, scale: 0.95 }}
        animate={{ opacity: 1, scale: 1 }}
        exit={{ opacity: 0, scale: 0.95 }}
        className="inline-flex items-center gap-1.5 px-2 py-0.5 bg-primary text-primary-foreground rounded-full text-[11px]"
      >
        <Loader2 className="w-3 h-3 animate-spin" />
        <span className="font-medium">
          {analyzingCount} en analyse
        </span>
        <div className="w-10 h-1 bg-primary-foreground/30 rounded-full overflow-hidden">
          <motion.div 
            className="h-full bg-primary-foreground rounded-full"
            initial={{ width: 0 }}
            animate={{ width: `${progress}%` }}
            transition={{ duration: 0.3, ease: "easeOut" }}
          />
        </div>
        <span className="opacity-70 tabular-nums">
          {completedCount}/{totalRecentDocs}
        </span>
      </motion.div>
    </AnimatePresence>
  );
}
